module.exports = __webpack_public_path__ + "static/media/facebook-app.5ea18559.svg";